import type { MenuItem } from '@/types/user'
import type { RouteRecordRaw } from 'vue-router'

// 静态映射表：让 Vite 能分析并打包所有组件
const viewModules = import.meta.glob('../views/**/*.vue')

/**
 * 将菜单转成路由信息
 * 数据库中 path 是 /dashboard、/system/user 等绝对路径
 * 作为 admin 子路由需要相对路径（去掉前导 /）
 * 子路由还需要去掉父路径前缀（如 /system/user → user）
 */
export function transformToRoutes(menus: MenuItem[]): RouteRecordRaw[] {
  return menus.flatMap((item): RouteRecordRaw[] => {
    const routePath = item.path.replace(/^\//, '')
    // 没有子级菜单
    if (!item.children || item.children.length === 0) {
      return [
        {
          path: routePath,
          name: item.name.replace(/\s/g, ''),
          component: viewModules[`../views/${item.component}`],
          meta: { title: item.title }
        }
      ]
    } else {
      // 子路由路径需要去掉父路径前缀，变为相对路径
      const parentPrefix = routePath + '/'
      const toRelative = (absolutePath: string) => {
        const p = absolutePath.replace(/^\//, '')
        return p.startsWith(parentPrefix) ? p.slice(parentPrefix.length) : p
      }

      const childrenRoutes = transformToRoutes(item.children).map(child => ({
        ...child,
        path: toRelative(child.path)
      }))

      return [
        {
          path: routePath,
          name: item.name.replace(/\s/g, ''),
          redirect: toRelative(item.children[0].path),
          meta: { title: item.title },
          children: childrenRoutes
        }
      ]
    }
  })
}
